<script>
  import EasyMDE from "easymde";
  import "easymde/dist/easymde.min.css";
	import { onMount, createEventDispatcher } from 'svelte';
	import { fade } from 'svelte/transition';
	import { send } from 'ionicons/icons/index.mjs';
  import { generateID, fetchData } from '../utils/Data.svelte';

	const dispatch = createEventDispatcher();
  export let modal;
  export let tooltips;
  export let session;
  let editor = null;
  let users = [];
  let selected = "";
  let subject = "";
  let notify = false;

  onMount(async () => {
    editor = new EasyMDE({
    element: document.getElementById("editor"),
      toolbar: [
        "bold",
        "italic",
        "heading",
        "unordered-list",
        "ordered-list",
        "link",
        "image",
        "preview",
      ],
    });
     let [res, err]  = await fetchData("/v1/users", {
          method: "GET",
          headers: {
              'Authorization': 'Bearer ' + session.token
          }
      });
		if (!err) {
      users = res.data.users;
      console.log(users);
    }
  });

  async function sendHandler(e) {
		e.currentTarget.blur();
    let [res, err] = await fetchData("/v1/messages", {
			method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + session.token
            },
      body: JSON.stringify({
				to: selected,
        subject: subject,
				body: editor.value(),
        notify: notify
			})
		});
    if (err) {
      dispatch('message', {
				type: "toast",
				data: {
					message: "Send error."
				}
			});
    } else {
      dispatch('message', {
				type: "toast",
				data: {
					message: "Message sent."
				}
			});
      close();
		}
  }

  function close() {
		dispatch('message', {
            type: "modal",
            modal: null
		});
  }
</script>

<div class="modal modal-lg active">
    <div class="modal-overlay" on:click={close} aria-label="Close"></div>
    <div id="modal-container" class="modal-container">
        <div class="modal-header">
            <div class="tile tile-centered">
                <div class="tile-content">
                    <div class="tile-title">Message</div>
                </div>
                <div class="tile-action">
                    <button class="btn btn-link {tooltips ? "tooltip tooltip-left" : ""}" data-tooltip="Send" on:click={sendHandler} aria-label="Send"><i class="svg svg-light">{@html send.md}</i></button>
                    <button class="btn btn-link {tooltips ? "tooltip tooltip-left" : ""}" data-tooltip="Close" on:click={close} aria-label="Close"><i class="icon icon-cross mt-1"></i></button>
                </div>
            </div>
        </div>
        <div class="modal-body">
          <select class="form-select" bind:value={selected}>
              <option value="" disabled hidden>Select user:</option>
              {#each users as user}
                {#if user}
                  <option value={user.id}>{user.name ? user.name : user.id}</option>
                {/if}
              {/each}
          </select>
          <div class="tile tile-centered mt-2">
              <div class="tile-content">
                  <div class="tile-title">Send Notification</div>
              </div>
              <div class="tile-action">
                  <div class="form-group" style="margin:0;">
                      <label id="offset" class="form-switch" style="margin:0;">
                          <input type="checkbox" bind:checked={notify}> 
                          <i class="form-icon"></i>
                      </label>
                  </div>
              </div>
          </div>
          <div class="form-group pb-1">
            <input class="form-input" type="text" bind:value={subject} placeholder="Subject">
          </div>
          <textarea id="editor"></textarea>
        </div>
    </div>
</div>

<style>
	.modal.modal-lg .modal-overlay {
        background: rgba(247, 248, 249, 0.75);
    }
    .modal.modal-lg .modal-container {
        height: 100vh;
        height: calc(var(--vh, 1vh) * 100);
        padding: 0;
    }
    .modal.modal-lg .modal-header {
        background-color: #00ab5f;
        color: #fff;
        padding: 0.2rem 0.4rem;
    }
    .modal.modal-lg .modal-header .btn.btn-link {
        color: white;
    }
    .modal.modal-lg .modal-body {
        padding: 10px;
        height: calc(100vh - 2.1rem);
    }
    ::-webkit-scrollbar {
      width: 6px;
      background-color: #f7f8f9;
    }
	  ::-webkit-scrollbar-thumb {
	  	background-color: rgba(122,129,132, 1);
    }
    #editor {
      height: 100%;
    }
</style>